import { useEffect } from 'react';
import Navbar from '@/components/brooklyn/Navbar';
import HeroSection from '@/components/brooklyn/HeroSection';
import HowItWorksSection from '@/components/brooklyn/HowItWorksSection';
import ProjectsSection from '@/components/brooklyn/ProjectsSection';

import StudioSection from '@/components/brooklyn/StudioSection';
import CuradoriaSection from '@/components/brooklyn/CuradoriaSection';
import MobileCTA from '@/components/brooklyn/MobileCTA';
import Footer from '@/components/brooklyn/Footer';
import LanguageBanner from '@/components/brooklyn/LanguageBanner';
import SectionDivider from '@/components/brooklyn/SectionDivider';
import { useEngagementTracking } from '@/hooks/useEngagementTracking';

const Index = () => {
  useEngagementTracking();
  useEffect(() => {
    if (window.fbq) { window.fbq('track', 'ViewContent'); }
  }, []);
  return (
    <div className="min-h-screen bg-background">
      <LanguageBanner />
      <Navbar />
      <main role="main">
        <HeroSection />
        <SectionDivider />
        <StudioSection />
        <SectionDivider />
        <HowItWorksSection />
        <SectionDivider />
        <ProjectsSection />
        <SectionDivider />
        <CuradoriaSection />
      </main>
      <MobileCTA />
      <Footer />
    </div>
  );
};

export default Index;
